import React, { useState } from 'react';

// ASSETS
import Logo from './assets/Logo';
import LogoSmall from './assets/LogoSmall';

// COMPONENTS
import Icon from '../Icon/Icon';
import MediaQuery from '../MediaQuery';
import SubSideBar from './SubSideBar';

// ENUMS
import { Themes } from '../../enums/themes';
import { Icons } from '../../enums/icons';

// INTERFACES
import { IMenuItemProps } from '../../interfaces/IMenuItem.interface';
import { ISideBarProps } from '../../interfaces/SideBar.interface';

// STYLES
import { Content, Container, WrapperLogo, Menu, Logout, LogoutLabel, LogoutIcon, ItemMenuContainer } from './styles';

const SideMenu: React.FC<ISideBarProps> = ({
  children,
  fixedPosition,
  items,
  onLogout,
  logoutId,
  themeProp = Themes.DARK
}: ISideBarProps) => {
  const [showSideMenu, setShowSideMenu] = useState(false);
  const [subItems, setSubItems] = useState([]);

  const onClick = (item: IMenuItemProps) => {
    if (item.subItems?.length > 0) {
      setSubItems(item.subItems);
      setShowSideMenu(true);
      return;
    }
    onMouseLeave();
  };

  const onMouseLeave = () => {
    setTimeout(() => {
      setShowSideMenu(false);
      setSubItems([]);
    }, 550);
  };

  const renderMenu = () => {
    if (items?.length > 0) {
      return items.map((item: IMenuItemProps, idx: number) => {
        const ItemMenu = item.itemMenu;

        return (
          <ItemMenuContainer key={idx} itemMenu={ItemMenu} active={item.active} onClick={() => onClick(item)}>
            <ItemMenu />
          </ItemMenuContainer>
        );
      });
    }
    return <></>;
  };

  return (
    <>
      <Container themeProp={themeProp} fixedPosition={fixedPosition}>
        <div>
          <WrapperLogo themeProp={themeProp}>
            <MediaQuery maxWidth={1359}>
              <Logo />
            </MediaQuery>
            <MediaQuery minWidth={1360}>
              <LogoSmall />
            </MediaQuery>
          </WrapperLogo>
          <Menu>
            {renderMenu()}
            <Logout id={logoutId} onClick={() => onLogout()}>
              <LogoutIcon themeProp={themeProp}>
                <Icon type={Icons.LOGOUT} />
              </LogoutIcon>
              <LogoutLabel themeProp={themeProp}>Sair</LogoutLabel>
            </Logout>
          </Menu>
        </div>
        <Content>{children}</Content>
      </Container>
      {showSideMenu && <SubSideBar onLeave={onMouseLeave} items={subItems} />}
    </>
  );
};

export default SideMenu;
